import { useStash } from '@tcc/shared-data-lib';
import { CROP_PLAN_INTEGRATION } from 'constants/cropPlanning';

export const useCropPlanStash = () => {
  return useStash(CROP_PLAN_INTEGRATION.project, CROP_PLAN_INTEGRATION.key);
};

